module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/758ce94395d932d4943f61b3cc96cd1e.png";